<template>
  <div>
    <JiraProjectIssues v-if="project.key" :project_key="project.key" />
    <b-card>
      <template #header>
        <h4 class="mb-0">{{ project.name }} Planned work load</h4>
      </template>
      <b-spinner v-if="spinners.contentIsLoading" type="grow" variant="primary" />
      <apexchart v-else width="100%" height="400px" type="area" :options="chartOptionsArea" :series="weekLoad">
      </apexchart>
    </b-card>
    <b-card>
      <template #header>
        <h4 class="mb-0">{{ project.name }} Gantt
          <i v-if="project.id"
            :class="['fa', 'fa-refresh', { 'fa-spin text-danger': syncing, 'text-warning': !syncing, }]"
            @click="syncProject(project.id)"></i>
        </h4>
      </template>
      <b-spinner v-if="spinners.contentIsLoading" type="grow" variant="primary" />
      <apexchart v-else width="100%" :height="chartHeight" type="rangeBar" :options="chartOptions" :series="ganttSeries">
      </apexchart>
    </b-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Pagination from 'laravel-vue-pagination';
import clone from 'lodash.clonedeep';
import moment from 'moment';
import VueApexCharts from 'vue-apexcharts';
import statuses from '../../../store/statuses';
import Services from '@/services';
// import vGantt from '@femessage/v-gantt';
import gantt from '@/views/components/dash/Gantt';
import JiraProjectIssues from '@/views/components/jira/JiraProjectIssues';

export default {
  mounted() {
    this.getData();
  },
  props: {
    id_or_key: { // project_id
      type: [Number, String],
      requred: true
    }
  },
  data() {
    return {
      syncing: false,
      spinners: {
        contentIsLoading: true,
      },
      issues: [],
      project: [],

      chartOptions: {
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '90%',
          }
        },
        xaxis: {
          type: 'datetime'
        },
        tooltip: {
          fixed: { position: 'bottomRight' },
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
            return '<ul class="tooltipgantt">'
              + `<li><b>From-To</b>: ${moment(data.y[0]).format('ll')} - ${moment(data.y[1]).format('ll')}</li>`
              + `<li><b>Spent H</b>: ${Math.round(data.raw.actual_timespent / 60 / 60)}</li>`
              + `<li><b>Original Estimate H</b>: ${Math.round(data.raw.timeoriginalestimate / 60 / 60)}</li>`
              + `<li><b>Remaining H</b>: ${data.raw.remaining_estimate}</li>`
              + `<li><b>Weeks Left</b>: ${data.raw.weeks_remaining}</li>`
              + `<li><b>Progress</b>: ${Math.round(data.raw.gantt_progress)}</li>`
              // `<li><b>hex</b>: ${ Math.round(255*(Math.max(Math.min(100,data.raw.gantt_progress),0)/100)).toString(16) }</li>` +
              + '</ul>';
          }
        },
        colors: [
          function ({ value, seriesIndex, w, dataPointIndex }) {
            const data = w.globals.initialSeries[seriesIndex].data[dataPointIndex];
            if (!data || !data.raw || !data.raw.gantt_progress) return '#02DFDE';
            const issue = data.raw;
            // return '#02DFDE';
            return `#0202${Math.round(255 - 225 * (Math.max(Math.min(100, data.raw.gantt_progress), 0) / 100)).toString(16)}`;
          }
        ]
      },

      chartOptionsArea: {
        plotOptions: {
        },
        stroke: {
          width: 1,
        },
        dataLabels: {
          formatter: function (val, opts) {
            return val > 0 ? val : '';
          },
        },
        xaxis: {
          type: 'datetime'
        }
      },
    };
  },
  components: {
    Pagination,
    gantt,
    apexchart: VueApexCharts,
    JiraProjectIssues,
  },
  computed: {
    ganttIssues() {
      let issues = this.issues
        .filter((i) => {
          return (i.type === 'Epic' || i.jira_issue_parent_id === null || ['PPP'].includes(this.project.key))
            && (i.gantt_from && i.gantt_to);
        })
        .map((i) => {
          i.timespent /= 3600;
          i.actual_timespent /= 3600;
          i.timeestimate /= 3600;
          i.timeoriginalestimate /= 3600;
          return i;
        }).map((i) => {
          // If task state is done set gant progress to 100%
          if (i.status && ["Done", "Dev is done", "Closed", "Ready to Accept", "Canceled", "Accepted by client"].includes(i.status.name)) i.gantt_progress = 100;
          const minPercentTrack = 5;
          const shouldHaveDone = (Math.max(1 * i.gantt_progress, minPercentTrack) / 100) * i.timeoriginalestimate;
          i.noprogress = !!i.labels.find((l) => l.label === 'noprogress');
          i.eac = Math.round(
            (i.gantt_progress < minPercentTrack || (i.actual_timespent < 1 && i.gantt_progress < 100))
              ? ((1 - i.gantt_progress / 100) * i.timeoriginalestimate + ((i.actual_timespent < shouldHaveDone) ? 0 : 1 * i.actual_timespent))
              : (i.actual_timespent === 0)
                ? 1 * i.timeoriginalestimate
                : ((i.actual_timespent / i.gantt_progress) * 100)
          );
          if (i.noprogress) i.eac = Math.max(1 * i.timeoriginalestimate, i.actual_timespent);
          i.etc = Math.max(0, Math.round(i.eac - i.actual_timespent));

          i.gantt_from = moment(i.gantt_from);
          i.gantt_to = moment(i.gantt_to);


          return i;
        })
        .sort((a, b) => {
          return (!a.gantt_from || (b.gantt_from && a.gantt_from > b.gantt_from)) ? 1
            : (!b.gantt_from || (a.gantt_from && a.gantt_from < b.gantt_from)) ? -1
              : 0;
        });

      // EAC,ETC sum for tasks with progress tracked (tasks with label noprgress are filtered out)
      const [eacTotal, etcTotal] = issues.filter(i => !i.noprogress).reduce(([eacTotal, etcTotal], i) => {
        return [eacTotal + 1 * i.eac, etcTotal + 1 * i.etc];
      }, [0, 0]);
      let totalDonePercent = Math.round((eacTotal - etcTotal) / eacTotal * 1000) / 10;

      issues = issues.map((i) => {
        // For no-progress tasks set progress  = totalDonePercent
        if (i.noprogress) {
          i.gantt_progress = totalDonePercent;
          i.eac = i.gantt_progress > 0 ? Math.round((i.actual_timespent / i.gantt_progress) * 100) : i.timeoriginalestimate;
          i.etc = Math.max(0, Math.round(i.eac - Math.round(i.actual_timespent)));
        }

        i.isActive = i.gantt_from.isBefore(moment()) && i.gantt_to.endOf('week').isAfter(moment());
        i.isExpired = i.gantt_to.isBefore(moment());
        i.weeks_remaining = i.gantt_to.startOf('week').add(1, 'weeks').diff(moment.max(moment(i.gantt_from), moment()).startOf('week'), 'days') / 7;
        i.avgLoad = (i.weeks_remaining <= 0 && i.etc > 0) ? -1 : Math.round(((i.etc / i.weeks_remaining) / 40) * 10) / 10 || 0;

        return i;
      });

      return issues;
    },
    ganttSeries() {
      return [{
        data: this.ganttIssues.map((i, idx) => {
          return {
            x: i.summary,
            y: [
              i.gantt_from.valueOf(),
              i.gantt_to.valueOf(),
            ],
            raw: i,
          };
        })
      }];
    },
    chartHeight() {
      return `${this.ganttIssues.length * 18 + 50}px`;
    },
    maxDate() { return moment.max(this.ganttIssues.map((e) => e.gantt_to)); },
    weeks() {
      const s = moment().startOf('week');
      // Last planned week no more than 24 months ahead
      const e = moment.min(moment(this.maxDate).startOf('week').add(1, 'weeks'), moment(s).add(4 * 24, 'weeks'));
      const weeks = [];
      for (let m = s; m.isBefore(e); m.add(1, 'weeks')) {
        weeks.push(moment(m)); // console.log(m.format('YYYY-MM-DD'));
      }
      return weeks;
    },
    weekLoad() {
      return [{
        data: this.weeks.map((w) => {
          const w2 = moment(w).add(7, 'days');
          const hoursLoadInWeek = this.ganttIssues.reduce((hours, i) => {
            return hours + (w.isBefore(i.gantt_to) && w2.isAfter(i.gantt_from) ? i.etc / i.weeks_remaining : 0);
          }, 0);
          return {
            x: w.valueOf(),
            y: Math.round(hoursLoadInWeek / 40 * 10) / 10,
          };
        })
      }];
    },

  },
  watch: {
  },
  methods: {
    getData() {
      const q = Number.isInteger(this.id_or_key) ? {
        id: this.id_or_key
      } : { key: this.id_or_key };
      Services.dash.projectIssues({ ...q, without_ignore_progress: true }).then(({ data }) => {
        this.issues = data.issues;
        this.project = data;
        this.project.issues = null;
        this.spinners.contentIsLoading = false;
      });
    },
    syncProject(id) {
      this.syncing = true;
      Services.dash.syncProject({ id }).then(() => {
        this.syncing = false;
      });
    }

  }
};
</script>

<style>
ul.tooltipgantt {
  list-style-type: none;
  padding: 1em;
  margin: 0;
}
</style>
